module.exports = __webpack_public_path__ + "public/img/logo_bukalapak.00d59525.svg";